import React from 'react'
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom'
import Cookies from 'universal-cookie';
const cookies = new Cookies()

const PublicRoute = ({ children }: any) => {
    const isAuthenticated = useSelector((e: any) => e.isAuthenticated);
    const authToken = cookies.get('skyTokenFront');
    
    if (authToken) {
        if (isAuthenticated?.changePassword) {
            return <Navigate to="/change/password" />;
        }
        return <Navigate to="/" />;
    }
    
    return children;
}

export default PublicRoute